<template>
  <div>
    <program-type-index
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :title="$t('menu.program_type_list')"
      :serviceName="serviceName"
    />
  </div>
</template>

<script>
import ProgramTypeIndex from "./ProgramTypeIndex";
export default {
  name: "Index",
  data() {
    return {
      serviceName: "program-types",
      formSearch: [
        {
          label: this.$t("program_type.name"),
          name: "name__~",
          value: "",
          type: "input"
        }
      ],
      columns: {
        id: this.$t("program_type.id"),
        name: this.$t("program_type.name"),
        description: this.$t("program_type.description"),
        created_at: this.$t("program_type.created_at"),
        updated_at: this.$t("program_type.updated_at")
      }
    };
  },
  components: { ProgramTypeIndex },
  methods: {},
  mounted() {}
};
</script>
